<ejs-dialog #dialog
  [visible]="visible"
  [isModal]="true"
  [showCloseIcon]="true"
  cssClass="modal-sm"
  (close)="close()">
  <ng-template #header>{{ dialogTitle }}</ng-template>
  <ng-template #content>
    <label class="form-label">{{ 'i18n.domain.vehicles.assign-dialog.profile-label' | translate }}</label>
    <app-dynamic-autocomplete
      [getDataFunction]="searchProfiles"
      [isFormComponent]="true"
      [formControl]="profileControl"
      [initialItem]="initialProfileItem"
      placeholder="i18n.domain.vehicles.assign-dialog.profile-placeholder">
    </app-dynamic-autocomplete>
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-outline-secondary me-2" type="button" (click)="close()">
      {{ 'i18n.domain.vehicles.assign-dialog.cancel' | translate }}
    </button>
    <button class="btn btn-primary" type="button" [disabled]="!canAssign" (click)="onAssign()">
      {{ 'i18n.domain.vehicles.assign-dialog.assign' | translate }}
    </button>
  </ng-template>
</ejs-dialog>
